<template>
  <v-content>
    <v-card
      max-width="480px"
      class="mx-auto px-5 py-2 my-5"
      justify="center"
      align="center"
      flat
    >
      <h2>About</h2>
      <v-card-subtitle>Under Development</v-card-subtitle>
    </v-card>
  </v-content>
</template>

<script>
export default {
  name: "About",
};
</script>

<style></style>
